import { useQuery} from '@apollo/client';
import { Queries } from "./common_queries";

export const LatestNews = () => {
    return useQuery(Queries.LatestNews);
}

export const FeaturedProperties = (department, search_type) => {
    return useQuery(Queries.FeaturedProperties,{
        variables:{department, search_type}
    });
}

export const FeaturedPropertiesOffice = (department, office_crm_id) => {
    return useQuery(Queries.FeaturedPropertiesOffice,{
        variables:{department, office_crm_id}
    });
}

export const FeaturedPropertiesAreas = (department, search_type, area_name) => {
    return useQuery(Queries.FeaturedPropertiesAreas,{
        variables:{department, search_type, area_name}
    });
}

export const BurgerMenu = () => {
    return useQuery(Queries.BurgerMenu);
}

export const TeamFilter = (category) => {
    return useQuery(Queries.TeamFilter,{
        variables:{category}
    });
}

export const PropertyDetails = (id) => {
    return useQuery(Queries.PropertyDetails,{
        variables:{id}
    });
}

export const NewsDetails = (slug) => {
    return useQuery(Queries.NewsDetails,{
        variables:{slug}
    });
}

export const OfficeDetails = (slug) => {
    return useQuery(Queries.OfficeDetails,{
        variables:{slug}
    });
}

export const NewHomesDetails = (id) => {
    return useQuery(Queries.NewHomesDetails,{
        variables:{id}
    });
}

export const PropertyNewhomesChild = (id) => {
    return useQuery(Queries.PropertyNewhomesChild,{
        variables:{id}
    });
}

export const OfficeList = () => {
    return useQuery(Queries.OfficeList);
}

export const AreaList = () => {
    return useQuery(Queries.AreaList);
}

export const AreaGuideList = () => {
    return useQuery(Queries.AreaGuideList);
}

export const PopularSearch = (slug) => {
    return useQuery(Queries.PopularSearch,{
        variables:{slug:slug}
    });
}

export const NewHomesProperties = (master_id) => {
    return useQuery(Queries.NewHomesProperties,{
        variables:{master_id}
    });
}

export const GetMenu = (slug) => {
    return useQuery(Queries.GetMenu,{
        variables:{slug}
    });
}

export const BranchDet = (id) => {
    return useQuery(Queries.BranchDet,{
        variables:{id}
    });
}

export const OfficeDetailsID = (crm_id) => {
    return useQuery(Queries.OfficeDetailsID,{
        variables:{crm_id}
    });
}